var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10511 14H0.542847V5.53186H3.10511V14ZM12 14H9.43774V9.4763C9.43774 8.29754 9.01411 7.7107 8.17454 7.7107C7.50921 7.7107 7.08729 8.03926 6.87547 8.69724V14H4.31321C4.31321 14 4.34737 6.37867 4.31321 5.53186H6.33569L6.49199 7.22548H6.54494C7.07021 6.37867 7.90977 5.80453 9.06108 5.80453C9.93652 5.80453 10.6446 6.04587 11.1852 6.65219C11.7293 7.25935 12 8.07398 12 9.21802V14Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82384 4.54043C2.55497 4.54043 3.14767 3.97173 3.14767 3.27021C3.14767 2.56869 2.55497 2 1.82384 2C1.0927 2 0.5 2.56869 0.5 3.27021C0.5 3.97173 1.0927 4.54043 1.82384 4.54043Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17H10.25C9.84 17 9.5 16.66 9.5 16.25C9.5 15.84 9.84 15.5 10.25 15.5H17.25C17.66 15.5 18 15.84 18 16.25C18 16.66 17.66 17 17.25 17Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.88H14.25C13.84 13.88 13.5 13.54 13.5 13.13C13.5 12.72 13.84 12.38 14.25 12.38H17.25C17.66 12.38 18 12.72 18 13.13C18 13.54 17.66 13.88 17.25 13.88Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.75H14.25C13.84 10.75 13.5 10.41 13.5 10C13.5 9.59 13.84 9.25 14.25 9.25H17.25C17.66 9.25 18 9.59 18 10C18 10.41 17.66 10.75 17.25 10.75Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.62H14.25C13.84 7.62 13.5 7.28 13.5 6.87C13.5 6.46 13.84 6.12 14.25 6.12H17.25C17.66 6.12 18 6.46 18 6.87C18 7.28 17.66 7.62 17.25 7.62Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.5H10.25C9.84 4.5 9.5 4.16 9.5 3.75C9.5 3.34 9.84 3 10.25 3H17.25C17.66 3 18 3.34 18 3.75C18 4.16 17.66 4.5 17.25 4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinList);
export default __webpack_public_path__ + "static/media/linkedin-list.05998b281b6b17a7d56994d2b8cbfd0f.svg";
export { ForwardRef as ReactComponent };